import {REGISTER_ADD_USERS } from '../types'

const initialState = {
    response: null,
    create:false,
    detail:false,
}

export default function authRegisterAddReducer(state = initialState, action) {
    switch (action.type) {
        case REGISTER_ADD_USERS:
            return {
                ...state,
                create:true,
                detail:false,
                response: action.payload,
            }
        default: return state
    }

}


